import { get, map, sortBy, set, cloneDeep, reduce } from 'lodash-es';
import { checkIsNull } from '../../Utils/utils';
import { RoleField } from './QuotationBlock.enum';

/**
 * get Questions Transform
 * @param {*} datagetQuestionsTransform
 */
export const getQuestionsTransform = ({ data }) => {
  try {
    // get Item Question
    const getItemQuestion = (itemQuestions, idPartie, idGroup, idArea) => {
      const question = cloneDeep(itemQuestions);
      set(question, 'idPartie', idPartie);
      set(question, 'idGroup', idGroup);
      set(question, 'idArea', idArea);
      return question;
    };

    // get item area
    const getItemArea = (itemArea, idPartie, idGroup) => {
      const idArea = get(itemArea, 'id');
      // map questions
      const questions = map(get(itemArea, 'questions'), itemQuestions =>
        getItemQuestion(itemQuestions, idPartie, idGroup, idArea)
      );
      return questions;
    };

    // get item group
    const getItemGroup = (itemGroups, idPartie) => {
      const idGroup = get(itemGroups, 'id');
      // map areas
      const areas = map(get(itemGroups, 'areas'), itemArea => getItemArea(itemArea, idPartie, idGroup)).flat();
      return areas;
    };

    // get item data
    const getItemData = itemData => {
      const idPartie = get(itemData, 'id');
      // map groups
      const groups = map(get(itemData, 'groups'), itemGroups => getItemGroup(itemGroups, idPartie)).flat();
      return groups;
    };

    // map parties
    const result = map(data, itemData => getItemData(itemData)).flat();
    return result;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`getQuestionsTransform ${e.stack}`);
  }
  return [];
};

/**
 * initialize questions
 * @param {*} questions
 */
export const initializeQuestionsFormik = ({ data }) => {
  try {
    const questions = getQuestionsTransform({ data });
    const result = reduce(
      questions,
      (item, val) => {
        // eslint-disable-next-line no-param-reassign
        item[val.code] = val.value;
        return item;
      },
      {}
    );
    return result;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`initializeQuestionsFormik: ${e}`);
  }
  return [];
};

/**
 * sort data transform
 * @param {*} param0
 */
export const initializeState = ({ data, schemaPartie }) => {
  try {
    // get item question
    const getItemQuestion = questionsItem => {
      const question = cloneDeep(questionsItem);
      //
      const value = get(question, 'value');
      const init = get(question, 'init');
      const role = get(question, 'custom_resources.options.role', RoleField.WRITE);
      const webInput = get(question, 'custom_resources.web_input');
      const disabled = role === RoleField.READ;
      const hidden = role === RoleField.HIDDEN;

      if (checkIsNull(value) && !checkIsNull(init)) {
        set(question, 'value', get(question, 'init'));
      }
      set(question, 'disabled', disabled);
      set(question, 'hidden', hidden);
      set(question, 'webInput', webInput);
      // remove custom_resources property from state
      // Reflect.deleteProperty(question, 'custom_resources');

      return question;
    };

    // get Item Areas
    const getItemAreas = itemAreas => {
      // get areas items
      const itemAreasClone = cloneDeep(itemAreas);
      const questions = sortBy(
        map(get(itemAreasClone, 'questions'), questionsItem => getItemQuestion(questionsItem)),
        item => get(item, 'sequence')
      );
      set(itemAreasClone, 'questions', questions);
      return itemAreasClone;
    };

    // get itemGroup
    const getItemGroup = itemGroups => {
      // get group items
      const itemGroupsClone = cloneDeep(itemGroups);
      const areas = sortBy(
        map(get(itemGroupsClone, 'areas'), itemAreas => getItemAreas(itemAreas)),
        item => get(item, 'sequence')
      );
      set(itemGroupsClone, 'areas', areas);
      return itemGroupsClone;
    };

    // get ItemData
    const getItemData = itemData => {
      // get data item
      const itemDataClone = cloneDeep(itemData);

      // role partie
      const role = get(itemDataClone, 'partie.custom_resources.options.role', RoleField.WRITE);
      const disabled = role === RoleField.READ; // disabled button remove partie
      const hidden = role === RoleField.HIDDEN; // hidden block partie
      set(itemDataClone, 'partie.disabled', disabled);
      set(itemDataClone, 'partie.hidden', hidden);

      // groups
      const groups = sortBy(
        map(get(itemDataClone, 'groups'), itemGroups => getItemGroup(itemGroups)),
        item => get(item, 'sequence')
      );
      set(itemDataClone, 'groups', groups);

      return itemDataClone;
    };

    const newData = sortBy(
      map(data, itemData => getItemData(itemData)),
      item => get(item, 'partie.isSubscriber') !== true
    );

    const state = {
      data: newData,
      schemaPartie,
      codeFirstError: undefined,
    };

    return state;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`initializeState: ${e}`);
  }
  return [];
};
